// reCAPTCHA v3, loaded from Google only on the registration page and only
// when the server has a site key.
type Grecaptcha = {
  ready: (cb: () => void) => void;
  execute: (siteKey: string, opts: { action: string }) => Promise<string>;
};

declare global {
  interface Window {
    grecaptcha?: Grecaptcha;
  }
}

let loading: Promise<Grecaptcha> | null = null;

function load(siteKey: string): Promise<Grecaptcha> {
  if (window.grecaptcha) return Promise.resolve(window.grecaptcha);
  loading ??= new Promise<Grecaptcha>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
    script.async = true;
    script.onload = () => (window.grecaptcha ? resolve(window.grecaptcha) : reject(new Error("recaptcha missing")));
    script.onerror = () => {
      loading = null;
      reject(new Error("recaptcha failed to load"));
    };
    document.head.appendChild(script);
  });
  return loading;
}

// preloadRecaptcha starts the script early so the submit doesn't wait on it.
export function preloadRecaptcha(siteKey: string): void {
  if (siteKey) void load(siteKey).catch(() => undefined);
}

// recaptchaToken returns a token for the register action, "" when there is
// no site key, and throws when the check can't run.
export async function recaptchaToken(siteKey: string): Promise<string> {
  if (!siteKey) return "";
  const g = await load(siteKey);
  await new Promise<void>((resolve) => g.ready(resolve));
  return g.execute(siteKey, { action: "register" });
}
